import { render, staticRenderFns } from "./CreateUserDataEmployeeModal.vue?vue&type=template&id=700a2aae&"
import script from "./CreateUserDataEmployeeModal.vue?vue&type=script&lang=js&"
export * from "./CreateUserDataEmployeeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports